import { render, staticRenderFns } from "./card-2.vue?vue&type=template&id=6b4e5290&scoped=true"
import script from "./card-2.vue?vue&type=script&lang=js"
export * from "./card-2.vue?vue&type=script&lang=js"
import style0 from "./card-2.vue?vue&type=style&index=0&id=6b4e5290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4e5290",
  null
  
)

export default component.exports